import React from 'react'
import { DepreciationMain } from './DepreciationMain'
import { DepreciationGenerateList } from './GenerateDepreciation/DepreciationGenerateList'
import { DepreciationGenerateSummary } from './GenerateDepreciation/DepreciationGenerateSummary'
import { HistoryDepreciation } from './GenerateDepreciation/HistoryDepreciation'
import { HistoryDepreciationDetail } from './GenerateDepreciation/HistoryDepreciationDetail'

const depreciationRoutes = [
  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/depreciation',
    },
    component: <DepreciationMain />,
  },

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/depreciation/generate-depreciation',
    },
    component: <DepreciationGenerateList />,
  },

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/depreciation/generate-depreciation/summary-depreciation',
    },
    component: <DepreciationGenerateSummary />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/depreciation/history',
    },
    component: <HistoryDepreciation />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/depreciation/history/:DepreciationLedgerID',
    },
    component: <HistoryDepreciationDetail />,
  },
]

export default depreciationRoutes
